/**
 * Calculates monthly rate
 * @param {number} msrp Manufacturer Retail Price
 * @param {number} docFee Documentation fee
 * @param {number} apr Annual Percentage Rate
 * @param {number} termMonths Number of months on which the payment gonna be divided by
 * @returns {number} The monthly rate of the asset
 */
export default function (msrp: number, docFee: number, apr: number, termMonths: number): number {
  let monthlyRate = Math.round(((msrp + docFee) * apr) / 100 / 12 / (1 - (1 + apr / 100 / 12) ** -termMonths));
  if (monthlyRate < 100) monthlyRate = 100;
  return monthlyRate;
}
